import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#344054",
      d: "M2.646 7.98a.5.5 0 1 0 .708.707l1.68-1.68.65.53a.5.5 0 0 0 .682-.046l1.635-1.758.634.676a.5.5 0 1 0 .73-.684l-1-1.067a.5.5 0 0 0-.731.001l-1.68 1.807-.638-.52a.5.5 0 0 0-.67.034z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#344054",
      "fill-rule": "evenodd",
      d: "M2.5 2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }